import { ShiftActionTypes } from './shift.types'

//Add Shift
export const addShiftRequest = data => ({
    type: ShiftActionTypes.ADD_SHIFT_REQUEST,
    payload: data
})

export const addShiftRequestSuccess = data => ({
    type: ShiftActionTypes.ADD_SHIFT_REQUEST_SUCCESS,
    payload: data
})

export const addShiftRequestError = data => ({
    type: ShiftActionTypes.ADD_SHIFT_REQUEST_ERROR,
    payload: data
})

export const addShiftRequestStatus = data => ({
    type: ShiftActionTypes.ADD_SHIFT_REQUEST_STATUS,
    payload: data
})

//Shift Detail
export const shiftDetailRequest = data => ({
    type: ShiftActionTypes.SHIFT_DETAIL_REQUEST,
    payload: data
})

export const shiftDetailRequestSuccess = data => ({
    type: ShiftActionTypes.SHIFT_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const shiftDetailRequestError = data => ({
    type: ShiftActionTypes.SHIFT_DETAIL_REQUEST_ERROR,
    payload: data
})

//Shift List
export const shiftListRequest = data => ({
    type: ShiftActionTypes.SHIFT_LIST_REQUEST,
    payload: data
})

export const shiftListRequestSuccess = data => ({
    type: ShiftActionTypes.SHIFT_LIST_REQUEST_SUCCESS,
    payload: data
})

export const shiftListRequestError = data => ({
    type: ShiftActionTypes.SHIFT_LIST_REQUEST_ERROR,
    payload: data
})

//Update Shift
export const updateShiftRequest = data => ({
    type: ShiftActionTypes.UPDATE_SHIFT_REQUEST,
    payload: data
})

export const updateShiftRequestSuccess = data => ({
    type: ShiftActionTypes.UPDATE_SHIFT_REQUEST_SUCCESS,
    payload: data
})

export const updateShiftRequestError = data => ({
    type: ShiftActionTypes.UPDATE_SHIFT_REQUEST_ERROR,
    payload: data
})

export const updateShiftRequestStatus = data => ({
    type: ShiftActionTypes.UPDATE_SHIFT_REQUEST_STATUS,
    payload: data
})

//Request Shift
export const requestShiftRequest = data => ({
    type: ShiftActionTypes.REQUEST_SHIFT_REQUEST,
    payload: data
})

export const requestShiftRequestSuccess = data => ({
    type: ShiftActionTypes.REQUEST_SHIFT_REQUEST_SUCCESS,
    payload: data
})

export const requestShiftRequestError = data => ({
    type: ShiftActionTypes.REQUEST_SHIFT_REQUEST_ERROR,
    payload: data
})

export const requestShiftRequestStatus = data => ({
    type: ShiftActionTypes.REQUEST_SHIFT_REQUEST_STATUS,
    payload: data
})

//Assign Shift
export const assignShiftRequest = data => ({
    type: ShiftActionTypes.ASSIGN_SHIFT_REQUEST,
    payload: data
})

export const assignShiftRequestSuccess = data => ({
    type: ShiftActionTypes.ASSIGN_SHIFT_REQUEST_SUCCESS,
    payload: data
})

export const assignShiftRequestError = data => ({
    type: ShiftActionTypes.ASSIGN_SHIFT_REQUEST_ERROR,
    payload: data
})

export const assignShiftRequestStatus = data => ({
    type: ShiftActionTypes.ASSIGN_SHIFT_REQUEST_STATUS,
    payload: data
})

//Remove Employee
export const removeShiftEmployeeRequest = data => ({
    type: ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST,
    payload: data
})

export const removeShiftEmployeeRequestSuccess = data => ({
    type: ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_SUCCESS,
    payload: data
})

export const removeShiftEmployeeRequestError = data => ({
    type: ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_ERROR,
    payload: data
})

export const removeShiftEmployeeRequestStatus = data => ({
    type: ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_STATUS,
    payload: data
})

//Decline request
export const declineRequestShiftRequest = data => ({
    type: ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST,
    payload: data
})

export const declineRequestShiftRequestSuccess = data => ({
    type: ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_SUCCESS,
    payload: data
})

export const declineRequestShiftRequestError = data => ({
    type: ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_ERROR,
    payload: data
})

export const declineRequestShiftRequestStatus = data => ({
    type: ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_STATUS,
    payload: data
})